import { Gem } from 'lucide-react'

type Size = 'sm' | 'md'

const sizeClass: Record<Size, { wrap: string; icon: number }> = {
  sm: { wrap: 'gap-1 px-2 py-0.5 text-[0.62rem] sm:px-2.5 sm:py-1 sm:text-[0.65rem]', icon: 11 },
  md: { wrap: 'gap-1.5 px-2.5 py-1 text-[0.65rem] sm:text-xs', icon: 12 },
}

export function EliteBadge({
  className = '',
  size = 'sm',
  rounded = 'md',
}: {
  className?: string
  size?: Size
  /** Match product card (`md`) vs PDP pill (`full`). */
  rounded?: 'md' | 'full'
}) {
  const s = sizeClass[size]
  const round = rounded === 'full' ? 'rounded-full' : 'rounded-md'
  return (
    <span
      className={`badge-elite ${round} inline-flex items-center font-bold uppercase tracking-[0.14em] shadow-lg ${s.wrap} ${className}`}
    >
      <Gem
        size={s.icon}
        className="shrink-0 text-[#c4d9ff] drop-shadow-[0_0_6px_rgba(0, 191, 255,0.85)]"
        strokeWidth={2.25}
        aria-hidden
      />
      Elite
    </span>
  )
}
